var React = require('react');

function ArrowRight (props) {
    return React.createElement("svg",props,React.createElement("g",{"fill":"none","fillRule":"evenodd"},[React.createElement("path",{"d":"M-5-5h24v24H-5z","key":0}),React.createElement("path",{"fill":"currentColor","fillRule":"nonzero","d":"m13.629 7.058-5.621 6.558L6.706 12.5l3.932-4.586L.5 7.915V6.201L10.638 6.2 6.706 1.616 8.008.5z","key":1})]));
}

ArrowRight.defaultProps = {"width":"14","height":"14","viewBox":"0 0 14 14"};

module.exports = ArrowRight;

ArrowRight.default = ArrowRight;
